import { drawOutline, getBorderRadius } from './canvasMethods'
import { appState } from './state'
import {
    tableauPlaceholderX,
    tableauPlaceholderY,
    foundationPlaceholderX,
    foundationPlaceholderY,
    wastePlaceholderX,
    wastePlaceholderY,
    stockPlaceholderX,
    stockPlaceholderY,
} from './allXYCoordinates'

export function drawTableauPlaceHolder(ctx: CanvasRenderingContext2D) {
    for (let i = 0; i < appState.NUM_TABLEAU; i++) {
        const x = tableauPlaceholderX(i)
        const y = tableauPlaceholderY(i)
        const size = appState.cardWidth * 0.4

        drawOutline(x + (appState.cardWidth - size) / 2, y + (appState.cardHeight - size) / 2, size, size, ctx)
    }
}
export function drawFoundationPlaceHolder(ctx: CanvasRenderingContext2D) {
    for (let i = 0; i < appState.NUM_FOUNDATIONS; i++) {
        const x = foundationPlaceholderX(i)
        const y = foundationPlaceholderY(i)
        const size = appState.cardWidth * 0.4

        drawOutline(x + (appState.cardWidth - size) / 2, y + (appState.cardHeight - size) / 2, size, size, ctx)
    }
}

export function drawWastePlaceHolder(ctx: CanvasRenderingContext2D) {
    const x = wastePlaceholderX()
    const y = wastePlaceholderY()
    const size = appState.cardWidth * 0.4

    drawOutline(x + (appState.cardWidth - size) / 2, y + (appState.cardHeight - size) / 2, size, size, ctx)
}

export function drawStockPlaceHolder(ctx: CanvasRenderingContext2D) {
    const x = stockPlaceholderX()
    const y = stockPlaceholderY()
    const radius = getBorderRadius()

    // Hollow outline at full card size — visually distinct from the filled
    // placeholders used for foundations/tableau/waste, but still reads as
    // a tappable empty slot.
    ctx.beginPath()
    ctx.roundRect(x, y, appState.cardWidth, appState.cardHeight, radius)
    ctx.lineWidth = Math.max(1.5, appState.cardWidth * 0.025)
    ctx.strokeStyle = appState.currentTheme.placeholderColor
    ctx.stroke()
}
